import { render, staticRenderFns } from "./NotificationsWrapper.vue?vue&type=template&id=48e9976c&"
import script from "./NotificationsWrapper.vue?vue&type=script&lang=js&"
export * from "./NotificationsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseNotification: require('/d3_frontend/base-tailwindcss-components/src/Notification.vue').default})
